import { userSessionCookieKey } from 'libs/common/cookies'

export const withUserSessionIdInterceptor = (userSessionId: string) => (request) => {
  if (userSessionId) {
    request.headers[userSessionCookieKey] = userSessionId
  }

  return request
}

export const withAuthorizationInterceptor = (axiosInstace: any) => (request) => {
  if (axiosInstace.accessToken) {
    request.headers['authorization'] = axiosInstace.accessToken
  }

  return request
}

export function requestTimeInterceptor(config) {
  config.headers['request-startTime'] = process.hrtime()
  return config
}
